import GuideSection from './GuideSection.js';

export default class GuideSubscriptionsSection extends GuideSection {
  static type = 'GuideSubscriptionsSection';
}